export const CardBuilder = ({
  id,
  finalFileURL,
  fileName,
  fileExtension,
  fileSize,
  isFileArchived,
  thumbNailURL,
  isCheck = [],
  handleClick = () => {},
  handleAdd = () => {},
  handleAddThumb = () => {},
  downloaded = false,
  handleRemove = () => {},
  handleRemoveThumb = () => {},
  sasToken = "",
}) => {
  const appendSasTokenToUrl = (url) => {
    if (!url || !sasToken) return url;
    // const separator = url.includes("?") ? "&" : "?";
    return `${url}${sasToken}`;
  };

  return (
    <div className="check">
      <label className="cont">
        <input
          key={id}
          id={id}
          type="checkbox"
          className="box"
          value={appendSasTokenToUrl(finalFileURL)}
          checked={isCheck.includes(String(id))}
          onChange={(e) => {
            handleClick(e);
            const isChecked = e.target.checked;
            const fileData =
              e.target.value + "$" + fileName + "$" + fileExtension + "$" + fileSize;
            if (isChecked) {
              handleAdd(fileData, isFileArchived);
              handleAddThumb(appendSasTokenToUrl(thumbNailURL));
              if (downloaded === true) {
                handleClick(e);
              }
            } else {
              handleRemove(fileData);
              handleRemoveThumb(appendSasTokenToUrl(thumbNailURL));
            }
          }}
        ></input>
      </label>
    </div>
  );
};

export const CardDownloadIcon = ({
  finalFileURL,
  isFileArchived,
  downloadProgress = {},
}) => {
  const entry = downloadProgress?.[finalFileURL];
  if (isFileArchived === "true") return null;

  const status = entry?.status ?? null;
  const percent = typeof entry?.percent === "number" ? entry.percent : null;

  const hideTooltip = status && status !== "completed";
  const showIcon = !status || status === "completed";

  const renderText = () => {
    if (status === "failed") return "Failed";
    if (status === "completed" || percent === 100) return "100%";
    if (typeof percent === "number") return `${percent}%`;
    return "…";
  };

  return (
    <span className={`downloadIconWrapper ${hideTooltip ? "hideTooltip" : ""}`}>
      {showIcon ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          viewBox="0 0 16 16"
          className="downloadIcon"
        >
          <path d="M.5 9.9a.5.5 0 0 1 .5.5v3.1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V10.4a.5.5 0 0 1 1 0v3.1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V10.4a.5.5 0 0 1 .5-.5z" />
          <path d="M7.646 10.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 9.293V1.5a.5.5 0 0 0-1 0v7.793L5.354 7.146a.5.5 0 1 0-.708.708l3 3z" />
        </svg>
      ) : (
        <span
          className={`downloadProgressText ${status === "failed" ? "failed" : ""}`}
          title={status === "failed" ? entry?.error || "Failed" : undefined}
        >
          {renderText()}
        </span>
      )}
    </span>
  );
};

export const Metadata = ({
  FileNo,
  dateOnImage,
  dbInsertedDateTime,
  logOnUserUploadTime,
  fileExtension,
  fileName,
  fileUploadedDateTime,
  latitude,
  longitude,
  engineerName,
  address,
  serviceAppointmentNumber,
  workOrderLineItemNumber,
  workOrderNumber,
}) => {

  const formatToUK = (iso) => {
    if (!iso) return "";
    try {
      const d = new Date(iso);

      // Convert date to UK time (Europe/London), but DON'T show GMT/BST
      const formatted = new Intl.DateTimeFormat("en-GB", {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
        timeZone: "Europe/London",
        timeZoneName: "short",
      }).format(d);

      return `${formatted}`;
    } catch {
      return iso;
    }
  };

  const formatGps = () => {
    const lon = longitude == null ? "0.00" : longitude;
    const lat = latitude == null ? "0.00" : latitude;
    return `${lon}   ${lat}`;
  };

  const formatFileName = () => {
    if (!fileName) return null;
    return fileName.includes(".")
      ? fileName
      : `${fileName}.${fileExtension}`;
  };

  return (
    <div className="metadata">
      <div className="row">
        <b>File No.:</b>
        <span>{FileNo}</span>
      </div>
      <div className="row">
        <b>WO No.:</b>
        <span>{workOrderNumber}</span>
      </div>
      <div className="row">
        <b>WOLI No.:</b>
        <span>{workOrderLineItemNumber}</span>
      </div>
      {serviceAppointmentNumber && (
        <div className="row">
          <b>SA No :</b>
          <span>{serviceAppointmentNumber}</span>
        </div>
      )}
      <div className="row">
        <b>Captured Date:</b>
        <span>{dateOnImage}</span>
      </div>
      <div className="row">
        <b>Upload Date/Time to AMS:</b>
        {/* <span>{dbInsertedDateTime}</span> */}
        <span title={logOnUserUploadTime || dbInsertedDateTime || fileUploadedDateTime || "N/A"}>
           {logOnUserUploadTime
            ? formatToUK(logOnUserUploadTime)
             : dbInsertedDateTime               
              ? formatToUK(dbInsertedDateTime)
               : fileUploadedDateTime
                 ? formatToUK(fileUploadedDateTime)           
                  : "N/A"}
        </span>
      </div>
      <div className="row">
        <b>Gps Loc. :</b>
        <span>{formatGps()}</span>
      </div>
      <div className="row">
        <b>Uploaded By:</b>
        <span>{engineerName}</span>
      </div>
      <div className="row">
        <b>Postcode:</b>
        <span>{address}</span>
      </div>
      <div className="row">
        <b>Filename:</b>
        <span>{formatFileName()}</span>
      </div>
    </div>
  );
};
